import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ContainerOutlined, UsbOutlined } from '@ant-design/icons';
import { translate } from '@smovilgps/optimus-intl';
import { Tabs } from 'antd';
import StripePlans from '../stripePlans';
import Models from '.';

const ModelStripePlanPage = () => {
	const items = [
		{
			label: (
				<>
					<UsbOutlined />
					<FormattedMessage {...translate('models')} />
				</>
			),
			key: '1',
			children: <Models />,
		},
		{
			label: (
				<>
					<ContainerOutlined />
					<FormattedMessage {...translate('stripePlans')} />
				</>
			),
			key: '2',
			children: <StripePlans />,
		},
	];

	return (
		<div className="view">
			<Tabs items={items} />
		</div>
	);
};

export default ModelStripePlanPage;
